/* import __COLOCATED_TEMPLATE__ from './standardized-address.hbs'; */
var _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { ChosenAddress, chosenAddressFromString } from '@banking/ui/models/checking/onboarding/address-confirmation';
import { assertInstanceOf, assertNonNullable } from '@banking/ui/utils/assert';
let StandardizedAddress = (_class = class StandardizedAddress extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "ChosenAddress", ChosenAddress);
  }
  get hasMultipleOptions() {
    return Boolean(this.args.normalizedAddressEntry) && Boolean(this.args.userInputAddressEntry);
  }
  onListSelectionsDidChange(event) {
    const val = assertInstanceOf(event, CustomEvent).detail.currentSelectionValues;
    if (val.length === 0) {
      this.args.onValueChange(null);
    } else {
      const firstElement = val[0];
      const chosenAddress = assertNonNullable(chosenAddressFromString(firstElement));
      this.args.onValueChange(chosenAddress);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "onListSelectionsDidChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onListSelectionsDidChange"), _class.prototype), _class);
export { StandardizedAddress as default };